import { filterSyncSelectOptionsByLabel } from '../../Select.utils'

import { ASYNC_SELECT_LOCAL_PAGE_SIZE } from './useAsyncSelectLocalData.constants'

// Shaped as an old-API page, which the async select reads by default
export function toAsyncSelectLocalPage({ options, page, search }) {
  const items = search
    ? options.filter(option => filterSyncSelectOptionsByLabel(option, search))
    : options
  const start = (page - 1) * ASYNC_SELECT_LOCAL_PAGE_SIZE

  return {
    data: {
      count: items.length,
      curr_page: page,
      pages: Math.max(
        Math.ceil(items.length / ASYNC_SELECT_LOCAL_PAGE_SIZE),
        1
      ),
      results: {
        objects: items.slice(start, start + ASYNC_SELECT_LOCAL_PAGE_SIZE),
      },
    },
  }
}
